import { Loader2, ReceiptText } from "lucide-react";
import React from "react";

// Reusable Card Component for consistent styling
const TransactionCard = ({ title, transactions }) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 flex flex-col">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">{title}</h3>

      {/* Table Header */}
      <div className="grid grid-cols-4 gap-4 pb-3 border-b border-gray-100 text-xs font-semibold text-gray-400 uppercase tracking-wider">
        <div>Date</div>
        <div>Txn Type</div>
        <div className="text-right">Amount</div>
        <div className="text-right">Balance</div>
      </div>

      {/* Table Body */}
      <div className="flex flex-col mt-2">
        {transactions && transactions.length > 0 ? (
          transactions.map((txn) => (
            <div
              key={txn.id}
              className="grid grid-cols-4 gap-4 py-1 border-b border-gray-50 last:border-transparent items-center text-sm transition-colors hover:bg-gray-50 px-2 -mx-2 rounded-lg"
            >
              {/* Date Column */}
              <div className="text-gray-500 whitespace-nowrap">
                {new Date(txn.created_at).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </div>

              {/* Details Column */}
              <div className="ml-2">
                <span
                  className="text-gray-700 text-wrap text-xs font-medium truncate"
                  title={txn.txn_type}
                >
                  {txn.txn_type || "Transaction"}
                </span>
                {/* <span
                  className="text-gray-400 text-xs truncate"
                  title={txn.narration}
                >
                  {txn.narration}
                </span> */}
              </div>

              {/* Amount Column */}
              <div
                className={`text-right font-semibold ${
                  txn.factor === "Cr" ? "text-emerald-600" : "text-rose-500"
                }`}
              >
                {txn.factor === "Cr" ? "+" : "-"}₹{txn.amount}
              </div>

              {/* Balance Column */}
              <div className="text-right text-gray-600 font-medium">
                ₹{txn.balance_after}
              </div>
            </div>
          ))
        ) : (
          /* Empty State */
          <div className="py-8 text-center flex flex-col items-center justify-center">
            <span className="text-gray-400 text-sm">
              No recent transactions
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

// Main Dashboard Component
const TransactionMain = ({ recentTxns, showLastTransactions , loading}) => {
  if (!showLastTransactions || !recentTxns) return null;

  const {
    qr_history = [],
    online_history = [],
    refund_history = [],
    admin_history = [],
  } = recentTxns;

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="w-full mx-auto">

<div className="flex items-center justify-between mb-1">
  <h2 className="flex items-center gap-3 text-2xl font-bold text-gray-900">
    <div className="flex items-center justify-center p-2 bg-blue-50 text-blue-600 rounded-xl">
      <ReceiptText size={24} strokeWidth={2.5} />
    </div>
    Recent Transactions
    
    {/* Loader stays right next to the text */}
    {loading && (
      <Loader2 size={22} className="animate-spin text-blue-600 ml-1" />
    )}
  </h2>
</div>

        {/* Grid layout for the 4 cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3 gap-6">
          {/* {qr_history?.length > 0 && ( */}
            <TransactionCard title="QR History" transactions={qr_history} />
          {/* )} */}
          {/* {online_history?.length > 0 && ( */}
            <TransactionCard
              title="Online History"
              transactions={online_history}
            />
          {/* )} */}
          {/* {refund_history?.length > 0 && ( */}
            <TransactionCard
              title="Refund History"
              transactions={refund_history}
            />
          {/* )} */}
          {/* {admin_history?.length > 0 && ( */}
            <TransactionCard
              title="Admin History"
              transactions={admin_history}
            />
          {/* )} */}
        </div>
      </div>
    </div>
  );
};

export default TransactionMain;
